import React, { useState } from "react"; 
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Home from "./Components/Pages/Home";
import PackageDetails from "./Components/Pages/PackageDetails";
import Inscription from "./Components/Pages/Inscription";
import About from "./Components/Pages/About";
import Offres from "./Components/Pages/Offres";
import TypeOffres from "./Components/Pages/TypeOffres";
import EspaceClient from "./Components/Pages/EspaceClient";
import Login from "./Components/Pages/Login";
import ScrollToTop from "./Components/ScrollToTop";

function App() {
  const [user, setUser] = useState(() => {
    const userData = localStorage.getItem("user");
    return userData ? JSON.parse(userData) : null;
  });

  return (
    <>
      <Header user={user} setUser={setUser} /> {/* Passer les props */}
      <div className="super_container">
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Navigate to="/Home" />} />
          <Route path="/Home" element={<Home />} />
          <Route path="/About" element={<About />} />
          <Route path="/Offres" element={<Offres />} />
          <Route path="/Inscription" element={<Inscription setUser={setUser} />} />
          <Route path="/Login" element={<Login setUser={setUser} />} /> 
          <Route path="/Package-details/:idPackage" element={<PackageDetails setUser={setUser} />} />
          <Route path="/type-offres/:idTypeOffre" element={<TypeOffres />} />
          <Route path="/espace-client" element={<EspaceClient setUser={setUser}/>} />
        </Routes>
      </div>
      <Footer />
    </>
  );
}

function Root() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}

export default Root;
